module.exports = __webpack_public_path__ + "img/9788963707389.694b65f2.jpg";